/**
 * Dawn's <product-form> (assets/product-form.js) resolves its cart target once,
 * in its constructor:
 *
 *   this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
 *
 * This theme renders neither element — the cart lives in the custom slidecart
 * overlay (sections/slidecart.liquid) instead. With this.cart null,
 * product-form.js's success handler takes its "no cart UI to update" branch and
 * does a full-page navigation to /cart instead of an in-place AJAX update. That
 * full reload is what showed up as "add to cart takes me to the cart page"
 * instead of the slidecart opening where the shopper already is.
 *
 * Registering a real (if inert) <cart-notification> element gives
 * product-form.js something to call getSectionsToRender() / setActiveElement()
 * / renderContents() on, so it takes its normal AJAX branch instead of
 * rendering Dawn's own drawer markup.
 *
 * renderContents() is deliberately a no-op: opening and refreshing slidecart
 * for this same add is already handled by the PUB_SUB_EVENTS.cartUpdate
 * subscriber in apa-legacy-chrome.js (it calls slideCartOpen() whenever
 * event.source === 'product-form'), and product-form.js publishes that event
 * *and* calls renderContents() for every successful add. Calling
 * slideCartOpen() from both fired two independent renderCart() runs for one
 * add, each appending the line item into an already-cleared wrapper —
 * shopper saw the same item rendered twice (or more, stacked with other
 * triggers) in the drawer.
 */
if (!customElements.get('cart-notification')) {
  customElements.define(
    'cart-notification',
    class extends HTMLElement {
      // No sections to server-render — slidecart rebuilds itself client-side.
      getSectionsToRender() {
        return [];
      }
      // Dawn uses this to restore focus when its own drawer closes; slidecart
      // manages its own focus trap, so there's nothing to do here.
      setActiveElement() {}
      // See file header: opening/refreshing slidecart already happens via
      // apa-legacy-chrome.js's cartUpdate subscriber for this same add.
      renderContents() {}
    }
  );
}
